import React from "react";
import { ChevronUp, ChevronsUpDown, ChevronDown } from "lucide-react";

export function HeaderSort({ column }) {
  const sortDirection = column.getIsSorted();
  const isActive = !!sortDirection;

  return column.getCanSort() ? (
    <button
      onClick={column.getToggleSortingHandler()}
      style={{
        padding: 0,
        border: "none",
        cursor: "pointer",
        zIndex: 5,
        backgroundColor: "transparent",
        color: isActive ? "var(--color-highlight)" : "inherit",
      }}
    >
      {sortDirection === "asc" ? (
        <ChevronUp size={16} />
      ) : sortDirection === "desc" ? (
        <ChevronDown size={16} />
      ) : (
        <ChevronsUpDown size={16} />
      )}
    </button>
  ) : null;
}
